<template>
    <div class=" uk-margin-remove-top" style="background-image: url('/giveBg1.jpg'); background-size: cover">
        <div class="uk-padding" style="background-color: rgba(250, 250, 250, 0.9); ">
            <div class="uk-container uk-container-small">
                <div class="uk-child-width-1-2@m" uk-grid>
                    <div>
                        <h2 class="uk-text-bold">Give a gift as God has given to you</h2>
                        <p class="uk-text-small" style="font-weight: 600">You can help in many ways, help us to further our cause.</p>

                        <p>
                            Students of Northern Caribbean University are benefactors of many years of prayerful financial support and thousands of donors each year.
                            It's through our gifted faculty and your generous support that students receive the very best
                            Seventh Day Adventist Institutions and go into the world serving God in their field.
                        </p>
                        <p>
                            Together, as a family we invest in our students and help our faculty to go further so they
                            can serve the community and create a cycle that will stir a change in the world.
                        </p>
                        <p>
                            For this we pray for you always and hope that you continue helping us to change lives.

                        </p>
                    </div>
                    <div class="uk-padding-small uk-margin-top">
                        <div class="" >
                            <div class="uk-height-large"  >
                                <br><br>
                                <h3 class="uk-text-uppercase uk-text-center">Give to a future today</h3>
                                <router-link to="/donate">
                                    <small class="uk-align-center uk-text-center">Click here to donate <br></small>
                                    <img src="../../assets/donate.png" alt="">
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "giveAGift"
    }
</script>

<style scoped>
    .half-a-border-on-top {
        border-top: 15px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        left:0;
        top:-16px;
    }
    @media screen and (max-width:600px){


        h3{
            font-size: 1.2em !important;
        }
        h2{
            font-size: 1.3em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
